import React from 'react';

import Option from 'ui-library/menus/Option';

interface Actions {
  deleteBlock: () => void;
}

interface Props {
  actions: Actions;
}

export default function getDeleteBlockOption(props: Props): JSX.Element {
  return (
    <Option
      icon="delete"
      onSelect={props.actions.deleteBlock}
      dataTestAttrs={{
        component: 'BaseBlockOverflowDropdown',
        element: 'menuOption',
        key: 'deleteBlock',
      }}
    >
      Delete
    </Option>
  );
}
